import api from "../api";

interface TemplateResponse {
  public_id: string;
  payment_status: string;
}

const processTemplate = (templateId: string | null) => {
  if (!templateId) {
    return api.get<TemplateResponse>('/api/template/blank');
  }

  return api.get<TemplateResponse>(`/api/template?templateId=${templateId}`);
};

export const template = {
  processTemplate,
};